module.exports = __webpack_public_path__ + "img/edc-kredivo.e62a8240.png";